import React, { useEffect } from 'react';

function ContaModal({ show, onClose, onSubmit, form, handleChange, programas = [], bancos = [], agencias = [], title = 'CADASTRO DE CONTA' }) {
  // Auto-select when there is exactly one banco available
  useEffect(() => {
    if (!show) return;
    if (bancos.length === 1 && !form.idBanco) {
      handleChange({ target: { name: 'idBanco', value: bancos[0].id } });
    }
  }, [show, bancos.length]);

  // Auto-select when there is exactly one agência for the selected banco
  useEffect(() => {
    if (!show || !form.idBanco) return;
    const filtered = agencias.filter(a => String(a.idBanco) === String(form.idBanco));
    if (filtered.length === 1 && !form.idAgencia) {
      handleChange({ target: { name: 'idAgencia', value: filtered[0].idAgencia } });
    }
  }, [show, form.idBanco, agencias.length]);

  if (!show) return null;
  return (
    <div className="modal show d-block" tabIndex="-1"
      style={{ backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1055, position: 'fixed', inset: 0 }}>
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header bg-success text-white" style={{ padding: '0.35rem 1rem' }}>
            <h6 className="modal-title mb-0 small"><i className="bi bi-credit-card me-2"></i>{title}</h6>
            <button type="button" className="btn-close btn-close-white" onClick={onClose}></button>
          </div>
          <div className="modal-body">
            <form onSubmit={onSubmit}>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Programa *</label>
                  <select className="form-select form-select-sm" name="idPrograma" value={form.idPrograma} onChange={handleChange} required>
                    <option value="">Selecione...</option>
                    {programas.map(p => <option key={p.id} value={p.id}>{p.descricao}</option>)}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Nº Conta *</label>
                  <input type="text" className="form-control form-control-sm" name="numConta" value={form.numConta} onChange={handleChange} required />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Banco</label>
                  <select className="form-select form-select-sm" name="idBanco" value={form.idBanco} onChange={handleChange}>
                    <option value="">Selecione...</option>
                    {bancos.map(b => <option key={b.id} value={b.id}>{b.nome}</option>)}
                  </select>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Agência</label>
                  <select className="form-select form-select-sm" name="idAgencia" value={form.idAgencia} onChange={handleChange} disabled={!form.idBanco}>
                    <option value="">{form.idBanco ? 'Selecione...' : 'Selecione um banco'}</option>
                    {agencias.filter(a => String(a.idBanco) === String(form.idBanco))
                      .map(a => <option key={a.idAgencia} value={a.idAgencia}>{a.idAgencia}</option>)}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="form-label d-block">Debitar</label>
                  <div className="form-check form-switch mt-1">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="debitarSwitch"
                      checked={form.debitar === 'SIM'}
                      onChange={e => handleChange({ target: { name: 'debitar', value: e.target.checked ? 'SIM' : 'NÃO' } })}
                    />
                    <label className="form-check-label" htmlFor="debitarSwitch">
                      {form.debitar === 'SIM' ? 'Sim' : 'Não'}
                    </label>
                  </div>
                </div>
              </div>
              <div className="d-flex justify-content-end gap-2">
                <button type="button" className="btn btn-secondary" onClick={onClose}>Cancelar</button>
                <button type="submit" className="btn btn-success">Salvar</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContaModal;
